export default __webpack_public_path__ + "static/media/magento.96f23b1c.png";